import { render, staticRenderFns } from "./EtcButton.vue?vue&type=template&id=12117d2c&scoped=true"
import script from "./EtcButton.vue?vue&type=script&lang=js"
export * from "./EtcButton.vue?vue&type=script&lang=js"
import style0 from "./EtcButton.vue?vue&type=style&index=0&id=12117d2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12117d2c",
  null
  
)

export default component.exports